/* eslint-disable @typescript-eslint/no-use-before-define */
import { Locale } from "../../locales/index.mjs";
import { withCache } from "../../utils/index.mjs";
import { IntlMessageFormat } from "./types.mjs";
export var getPluralRules = withCache(locale => new Intl.PluralRules(Locale.from(locale).isoCode));
export function formatMessageFragment(locale, _ref, dictionary) {
  var _ref2, _dictionary$id;
  var {
    id,
    defaultMessage
  } = _ref;
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var format = (_ref2 = (_dictionary$id = dictionary[id]) !== null && _dictionary$id !== void 0 ? _dictionary$id : prepareMessage(defaultMessage)) !== null && _ref2 !== void 0 ? _ref2 : [{
    type: 0,
    value: "[".concat(id, "]")
  }];
  return format.flatMap(token => formatToken(locale, token, values));
}
export function formatMessageString(locale, _ref3, dictionary) {
  var _ref4, _dictionary$id2;
  var {
    id,
    defaultMessage
  } = _ref3;
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var format = (_ref4 = (_dictionary$id2 = dictionary[id]) !== null && _dictionary$id2 !== void 0 ? _dictionary$id2 : prepareMessage(defaultMessage)) !== null && _ref4 !== void 0 ? _ref4 : [{
    type: IntlMessageFormat.Type.LITERAL,
    value: "[".concat(id, "]")
  }];
  return format.flatMap(token => formatToken(locale, token, values)).join('');
}
var prepareMessage = withCache(message => typeof message !== 'undefined' ? parseMessage(message) : undefined);
function formatToken(locale, token) {
  var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var poundValue = arguments.length > 3 ? arguments[3] : undefined;
  if (token.type === IntlMessageFormat.Type.LITERAL) {
    return [token.value];
  }
  if (token.type === IntlMessageFormat.Type.ARGUMENT) {
    var _values$token$value;
    return [(_values$token$value = values[token.value]) !== null && _values$token$value !== void 0 ? _values$token$value : "{".concat(token.value, "}")];
  }
  if (token.type === IntlMessageFormat.Type.PLURAL) {
    var _ref5, _token$options;
    var value = values[token.value];
    if (typeof value !== 'number') {
      throw new Error("Invalid message parameters given. {".concat(token.value, "} param is required to be a number."));
    }
    var option = (_ref5 = (_token$options = token.options["=".concat(value)]) !== null && _token$options !== void 0 ? _token$options : token.options[getPluralRules(locale).select(value)]) !== null && _ref5 !== void 0 ? _ref5 : token.options.other;
    return option.value.flatMap(x => formatToken(locale, x, values, value));
  }
  if (token.type === IntlMessageFormat.Type.POUND) {
    return [String(poundValue !== null && poundValue !== void 0 ? poundValue : '#')];
  }
  throw new Error("Unsupported token: ".concat(JSON.stringify(token)));
}
export function parseMessage(message) {
  if (message.length === 0) {
    return [{
      type: 0,
      value: message
    }];
  }
  var format = [];
  tokenizeMessage(message).forEach(token => {
    // literal: "hello"
    if (!token.startsWith('{') || !token.endsWith('}')) {
      format.push({
        type: 0,
        value: token
      });
      return;
    }

    // plural placeholder: "{var, plural, ...}"
    if (token.indexOf(',') >= 0) {
      var _token$split$;
      var name = ((_token$split$ = token.split(/[{,}]/)[1]) !== null && _token$split$ !== void 0 ? _token$split$ : '').trim();
      format.push({
        type: 1,
        value: name
      });
      return;
    }

    // (assuming) argument: "{var}"
    format.push({
      type: 1,
      value: token.substring(1, token.length - 1)
    });
  });
  return format;
}
export function tokenizeMessage(message) {
  var tokens = message.split(/([{}])/);
  var nesting = 0;
  var result = [];
  var buffer = '';
  tokens.forEach(token => {
    switch (token) {
      case '{':
        if (nesting === 0 && buffer.length > 0) {
          result = [...result, buffer];
          buffer = '';
        }
        buffer += token;
        nesting += 1;
        break;
      case '}':
        buffer += token;
        nesting -= 1;
        if (nesting === 0) {
          result = [...result, buffer];
          buffer = '';
        }
        break;
      default:
        buffer += token;
    }
  });
  if (buffer.length > 0) {
    return [...result, buffer];
  }
  return result;
}